import React from 'react'
import Navigation from '../Navigation/Navigation'

const Header = profileInfo => {
  return <Navigation profileInfo={profileInfo} />
}

export default Header
